<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-13 11:53:48
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-05 10:58:40
 * @name: 商品权限
 * @Description: 商品权限
 * @FilePath: \preSaleNafterSaleBackstage\src\components\pianoCompanyManage\dialog\jurisdiction.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <dialog-normal ref="dialogNormal" title="商品管理">
    <template v-slot:main>
      <div class="transform">
        <container-normal title="可选">
          <template v-slot:containerNormal>
            <div class="container">
              <jurisdiction-set :jurisdiction="jurisdiction"></jurisdiction-set>
            </div>
          </template>
        </container-normal>
        <container-normal title="已选">
          <template v-slot:containerNormal>
            <div class="container">
              <jurisdiction-get
                :id="id"
                :jurisdiction="jurisdiction"
                v-if="jurisdiction.catagoryGoods.length > 0"
              ></jurisdiction-get>
            </div>
          </template>
        </container-normal>
      </div>
    </template>
    <template v-slot:foot>
      <el-button size="mini" plain @click="cancel">取消</el-button>
      <el-button size="mini" type="primary" @click="confirm">确定</el-button>
    </template>
  </dialog-normal>
</template>
<script>
import dialogNormal from "@/components/public/dialog-normal.vue";
import containerNormal from "@/components/public/container-normal.vue";
import jurisdiction from "@/object/transform/jurisdiction.class.js";
import jurisdictionSet from "@/components/pianoCompanyManage/jurisdiction-set.vue";
import jurisdictionGet from "@/components/pianoCompanyManage/jurisdiction-get.vue";
import { debounceation } from "@/utils/decorator";

export default {
  name: "pianoCompany-jurisdiction",
  components: {
    dialogNormal,
    containerNormal,
    jurisdictionSet,
    jurisdictionGet,
  },
  data() {
    return {
      id: "",
      jurisdiction: new jurisdiction(),
    };
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 打开dialog
     */
    open(id) {
      this.id = id || "";
      this.jurisdiction.treeDataGet = [];
      this.$refs.dialogNormal.open();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 关闭dialog
     */
    @debounceation(300)
    cancel() {
      this.$refs.dialogNormal.close();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击确定
     */
    @debounceation(300)
    confirm() {
      this.$emit("confirm", {
        id: this.id,
        arr: this.jurisdiction.treeDataGet,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.transform {
  width: 100%;
  @include grid-column(2, 1fr, 20px);
  .container {
    width: 400px;
    height: 500px;
  }
}
</style>
